import { doc, setDoc } from "firebase/firestore";
import { DEFAULT_EVALUATION_METRIC_VERSION_ID } from "~/types/EvaluationMetric";

export const useDocumentStyleDiagnostics = (documentId: string) =>
  defineStore(`/document/${documentId}/diagnostics/style`, () => {
    const diagnosticsLabel = ref("Checking document style...");
    const hasPassedDiagnostics = ref(false);
    const diagnosticsErrorMessage = ref<string | undefined>(undefined);

    const submittedDocumentStore = useSubmittedDocumentStore(documentId);
    const { revision } = storeToRefs(submittedDocumentStore);

    const isRunning = ref(false);
    const runDiagnostics = async (diagnosticsConfig: any) => {
      isRunning.value = true;

      await Promise.all(
        diagnosticsConfig.diagnostics.map(async (diagnostic: any) => {
          return runDiagnostic(diagnostic);
        })
      );

      // Check if all the diagnostics have undefined erro
      if (
        diagnosticsConfig.diagnostics.every(
          (diagnostic: any) => diagnostic.errorMessage == undefined
        )
      ) {
        hasPassedDiagnostics.value = true;
        ``;
        diagnosticsErrorMessage.value = undefined;
      } else {
        hasPassedDiagnostics.value = false;
        diagnosticsErrorMessage.value = diagnosticsConfig.defaultErrorMessage;
      }

      isRunning.value = false;
    };

    const runDiagnostic = async (diagnostic: any) => {
      if (revision.value == undefined || revision.value.id == undefined) return;

      diagnostic.isEvaluationRunning = true;

      const db = useFirestore();

      const resultsRef = doc(
        db,
        `/documents/${documentId}/revisions/${revision.value.id}/evaluationResults/${diagnostic.metricId}`
      );

      await setDoc(resultsRef, {
        status: EvaluationResultsStatus.evaluating,
        createdOnTimestamp: new Date().getTime(),
        lastUpdatedTimestamp: new Date().getTime(),
        versionId: DEFAULT_EVALUATION_METRIC_VERSION_ID,
      });

      const response = await $fetch(`/api/document/metric/evaluate`, {
        method: "POST",
        headers: await useApiHeaders(),
        body: {
          documentId: documentId,
          revisionId: revision.value.id,
          metricId: diagnostic.metricId,
          runInBackground: false,
          urgent: true,
        },
      });

      const evaluationResults = response as EvaluationResults;
      const criteria = evaluationResults.evaluationResult[0];
      const relevantInstances = criteria.relevantInstances;

      if (relevantInstances.length == 0) {
        diagnostic.errorMessage =
          diagnostic.errorCodeMap["no-relevant-instances"];
        diagnostic.isEvaluationRunning = false;
        return;
      }

      if (diagnostic.expectedInBodyParagraphs != undefined) {
        var numExpected = diagnostic.expectedInBodyParagraphs.length;

        if (numExpected > relevantInstances.length) {
          diagnostic.errorMessage =
            diagnostic.errorCodeMap["not-enough-instances"];
          diagnostic.isEvaluationRunning = false;
          return;
        }
      }

      diagnostic.isEvaluationRunning = false;
    };

    return {
      isRunning,
      runDiagnostics,
      hasPassedDiagnostics,
      diagnosticsErrorMessage,
    };
  });
